const ITEMS = [
  "Precision Meets Peace",
  "Craft",
  "Midtown Atlanta",
  "Est. 2021",
  "You Own It. Live It.",
  "25+ Years of Mastery",
];

export default function Marquee() {
  const row = [...ITEMS, ...ITEMS];
  return (
    <section
      id="marquee"
      className="relative bg-black py-5 md:py-10 overflow-hidden border-y border-white/10"
      data-testid="editorial-marquee"
    >
      <div className="marquee-track">
        {row.map((t, i) => (
          <span
            key={i}
            className="inline-flex items-center gap-8 px-8 font-serif italic text-3xl sm:text-4xl md:text-5xl lg:text-6xl leading-none tracking-tight text-white/90"
          >
            {t}
            <span className="w-2 h-2 rounded-full bg-white/40 inline-block" />
          </span>
        ))}
      </div>
    </section>
  );
}
